import {PureComponent} from 'react';
import {Field} from 'apstra-ui-common';

import IntegerListDropdownControl from './IntegerListDropdownControl';

export default class IntegerListDropdownInput extends PureComponent {
  static defaultProps = {
    noResultsMessage: 'Start typing to add a new integer',
    placeholder: 'No items specified',
    allowAdditions: true
  };

  render() {
    const {
      noResultsMessage, placeholder, allowAdditions,
      name, value, required, schema, disabled, errors, onChange
    } = this.props;

    return (
      <Field
        label={schema?.title ?? name}
        description={schema?.description}
        required={required}
        disabled={disabled}
        errors={errors}
      >
        <IntegerListDropdownControl
          allowAdditions={allowAdditions}
          noResultsMessage={noResultsMessage}
          placeholder={placeholder}
          value={value}
          onChange={onChange}
        />
      </Field>
    );
  }
}
